module.exports = __webpack_public_path__ + "img/bfcf944.jpg";